import React, { useEffect } from "react";
import { FormLoginScheme } from "../../../Models/Schemas/form-login";
import { FORM_LOGIN } from "../../../Constants/Login";
import Button from "../../Elements/Button/Button";
import { setErrorFormSimpleUtil } from "../../../Utilities/Forms/errors";
import useForm from "../../../Hooks/useForm";
import Input from "../../Elements/Input/Input";
import Loader from "../../Elements/Loader/Loader";
import useStore from "../../../useStore";
import { useToast } from "../../../Contexts/Toast/toast.provider";
import "./login.css";

const LOGO = "/assets/imgs/logo-sin-fondo.webp";

const Login = () => {
  const showToast = useToast();
  const { fetchDataLogin, loading, error, success, resetError, resetSuccess } = useStore();

  useEffect(() => {
    if (error) {
      showToast("error", error);
      resetError();
    }
  }, [error, showToast, resetError]);

  useEffect(() => {
    if (success) {
      showToast("success", `¡Bienvenido a bordo${success.nombre ? `, ${success.nombre}` : ""}! 🚀`);
      resetSuccess();
    }
  }, [success, showToast, resetSuccess]);

  const { values, errors, touched, handleBlur, handleChange, isValid } =
    useForm(FORM_LOGIN, FormLoginScheme);

  const submit = () => {
    if (!isValid) return;
    fetchDataLogin(values);
  };

  if (loading) return <Loader message="Despegando…" submessage="Validando tus credenciales" />;

  return (
    <section className="login-pp">
      <span className="login-estrella-fugaz" aria-hidden="true" />
      <span className="login-estrella-fugaz login-estrella-fugaz-2" aria-hidden="true" />

      <div className="login-pp-card">
        <div className="login-pp-brand">
          <div className="login-pp-orbita" aria-hidden="true">
            <span className="login-pp-satelite" />
          </div>
          <div className="hero-logo-ship login-pp-logo">
            <img src={LOGO} alt="" aria-hidden="true" className="hero-logo-glow" />
            <img src={LOGO} alt="Pizza Planeta" className="hero-logo-img" />
          </div>
        </div>

        <h1 className="login-pp-eyebrow">Centro de control</h1>

        <form
          className="login-pp-form"
          onSubmit={(e) => {
            e.preventDefault();
            submit();
          }}
        >
          <Input
            value={values.email}
            label="Correo electrónico"
            labelColor="var(--login-label)"
            placeholder="tu@correo.com"
            type="email"
            inputMode="email"
            autoFocus
            onChange={handleChange("email")}
            onBlur={handleBlur("email")}
            error={setErrorFormSimpleUtil(errors, touched, "email")}
            success={!setErrorFormSimpleUtil(errors, touched, "email")}
          />
          <Input
            value={values.password}
            label="Contraseña"
            labelColor="var(--login-label)"
            placeholder="••••••••"
            onChange={handleChange("password")}
            onBlur={handleBlur("password")}
            error={setErrorFormSimpleUtil(errors, touched, "password")}
            success={!setErrorFormSimpleUtil(errors, touched, "password")}
            variant="Password"
          />

          <Button
            text="Despegar 🚀"
            color="red"
            fill
            action={submit}
            disabled={!isValid}
            classNames="w-100 login-pp-boton"
          />
        </form>

        <a href="/" className="login-pp-volver">
          ← Volver al menú
        </a>
      </div>
    </section>
  );
};

export default Login;
